import Validate from './validate.tsx';

export default Validate;